









import Vue from "vue";

import IconMuscular from "@joyz/app-core/assets/icons/white/Muscular.svg";

export default Vue.extend({
  name: "PracticeModeToast",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      icons: {
        muscular: IconMuscular
      }
    };
  }
});
